"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  en: {
    previous: 'Previous',
    next: 'Next',
    moreRows: '+{{count}} more',
    userGreeting: 'Hello, {{user}}!',
    dragFileOrExplore: 'Drag your file or <1>explore</1>',
    dragImageOrExplore: 'Drag your image or <1>explore</1>'
  },
  es: {
    previous: 'Anterior',
    next: 'Siguiente',
    moreRows: '+{{count}} más',
    userGreeting: '¡Hola, {{user}}!',
    dragFileOrExplore: 'Arrastra tu archivo o <1>explora</1>',
    dragImageOrExplore: 'Arrastra tu imagen o <1>explora</1>'
  },
  fr: {
    previous: 'Précédente',
    next: 'Suivante',
    moreRows: '+{{count}} de plus',
    userGreeting: 'Bonjour, {{user}}!',
    dragFileOrExplore: 'Faites glisser votre fichier ou <1>explorez</1>',
    dragImageOrExplore: 'Faites glisser votre image ou <1>explorez</1>'
  },
  de: {
    previous: 'Vorherige',
    next: 'Nächste',
    moreRows: '+{{count}} mehr',
    userGreeting: 'Hallo, {{user}}!',
    dragFileOrExplore: 'Ziehen Sie Ihre Datei oder <1>durchsuchen Sie sie</1>',
    dragImageOrExplore: 'Ziehen Sie Ihr Bild oder <1>erkunden Sie</1>'
  }
};